<template>
  <v-app>
    <v-expand-transition>
      <v-app-bar
        v-if="!$route.meta.withoutBar"
        color="primary"
        dense
        flat
        dark
        app
      >
        <div
          class="text-h5"
          style="cursor: default"
        >
          Turnero Eurodycar
        </div>
        <v-spacer></v-spacer>
        <v-menu
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              title="Opciones"
              icon
            >
              <v-icon>fas fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list class="py-2">
            <v-list-item
              class="my-n2"
              style="cursor: pointer"
              @click="dialog = true"
            >
              <v-list-item-title>
                <v-icon left small>fas fa-key</v-icon>
                Cambiar contraseña
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              class="my-n2"
              style="cursor: pointer"
              @click="logout()"
            >
              <v-list-item-title>
                <v-icon left small>fas fa-sign-out-alt</v-icon>
                Cerrar sesión
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </v-expand-transition>
    <v-expand-transition>
      <v-app-bar
        v-if="$route.meta.banner"
        height="100"
        app
      >
        <img
          src="/Eurodycar.webp"
          height="80"
        >
        <v-spacer></v-spacer>
        <div
          class="text-h4 pr-4"
        >
          {{ $store.state.hora }}
        </div>
      </v-app-bar>
    </v-expand-transition>
    <v-expand-transition>
      <v-app-bar
        v-if="$route.meta.calendar"
        height="56"
        app
      >
        <v-row class="font-weight-bold text-h5">
          <v-col style="max-width: 5%" class="d-flex align-center justify-center text-h6 black--text">
            HORA
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="lunes == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            LUNES {{ lunes }}
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="martes == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            MARTES {{ martes }}
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="miercoles == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            MIÉRCOLES {{ miercoles }}
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="jueves == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            JUEVES {{ jueves }}
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="viernes == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            VIERNES {{ viernes }}
          </v-col>
          <v-divider vertical></v-divider>
          <v-col
            :class="sabado == actual ? 'indigo lighten-4' : ''"
            class="d-flex align-center justify-center py-0"
          >
            SÁBADO {{ sabado }}
          </v-col>
        </v-row>
      </v-app-bar>
    </v-expand-transition>
    <v-main>
      <v-container fluid>
        <v-scroll-y-transition hide-on-leave>
          <router-view></router-view>
        </v-scroll-y-transition>
      </v-container>
    </v-main>
    <LoadingScreen />
    <CambiarClave v-model="dialog" />
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import { actualziarFechas } from './utils'
import LoadingScreen from './components/utils/LoadingScreen'
import CambiarClave from './components/CambiarClave'

export default {
  data () {
    return {
      dialog: false
    }
  },
  created () {
    this.$store.dispatch('loadLocalStorage')
    actualziarFechas()
  },
  updated () {
    actualziarFechas()
  },
  computed: {
    ...mapState(['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'actual'])
  },
  components: {
    LoadingScreen,
    CambiarClave
  },
  methods: {
    async logout () {
      await this.$store.dispatch('logout')
        .then(() => {
          // logout correcto
        })
        .catch((error) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Error al cerrar sesión',
            text: error,
          })
        })
    }
  }
}
</script>

<style>
#app {
  /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
  text-align: right;
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
  text-align: right;
}
</style>
